import React from "react";
import "../assets/css/loader/loader.css";

const StripeLoader = () => {
  return <div className="stripe-loader"></div>;
};

export default StripeLoader;
